import PracticeCountingGame from "../pages/PracticeGames/PracticeCountingGame";
import PracticeBidding from "../pages/PracticeGames/PracticeBidding";

// Registry of practice games. To add a new game: build its page component
// and add one entry here - the /practice index route and the routes in
// App.js are both generated from this list, so nothing else needs to change.
const practiceGames = [
  {
    id: "counting-game",
    path: "counting-game",
    title: "Game Point Counter",
    description:
      "Get better at keeping track of game points! Watch 24 cards flip one at a time and try to track the running total in your head.",
    component: PracticeCountingGame,
  },
  {
    id: "bidding-practice",
    path: "bidding-practice",
    title: "Practice Bidding",
    description:
      "Simulate the bidding phase of a real hand, with bots filling the other seats, and get feedback on whether you made the right call.",
    component: PracticeBidding,
  },
];

export default practiceGames;
